import React from 'react';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

interface NavigationGroupProps {
  id: string;
  label: string;
  icon: React.ReactNode;
  active: boolean;
  expanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export default function NavigationGroup({
  id, label, icon, active, expanded, onToggle, children,
}: NavigationGroupProps) {
  const contentId = `${id}-navigation`;
  return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          aria-controls={contentId}
          aria-expanded={expanded}
          onClick={onToggle}
          sx={{
            borderRadius: 2,
            mx: 1.5,
            mt: 0.75,
            mb: 0.25,
            py: 0.75,
            px: 1.5,
            backgroundColor: active ? '#F8FAFC' : 'transparent',
            '& .MuiListItemIcon-root': {
              minWidth: 36,
              color: active ? '#4F46E5' : '#64748B',
              '& .MuiSvgIcon-root': { fontSize: 20 },
            },
            '& .MuiListItemText-primary': {
              color: active ? '#4F46E5' : '#475569',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            },
            '&:hover': { backgroundColor: '#F1F5F9' },
          }}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={label} />
          {expanded ? <ExpandLess sx={{ color: '#64748B' }} /> : <ExpandMore sx={{ color: '#64748B' }} />}
        </ListItemButton>
      </ListItem>
      <Collapse id={contentId} in={expanded} timeout="auto" unmountOnExit>
        <List disablePadding>{children}</List>
      </Collapse>
    </>
  );
}
